import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import VisitDashboard from '@common/component/organisms/VisitDashboard';
import Layout from '../Layout';
import { GetVisitSummaryApiRequest } from '@common/external/VisitApi';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '@common/redux/modules/store';
import { dateToFormatString, getInquiryToday, VISIT_SUMMARY_SPOT_EVENT_MAPPING, HEARING_MODAL_SPOT_EVENT_MAPPING } from '@common/Common';
import { getVisitSummary, getVisitStoreList } from '@common/redux/operations/Visit';
import { AgencyAppState } from 'src/redux/modules/store';
import { GetHndlItmMngApiRequest } from '@common/external/HndlItmMngApi';
import { HNDL_ITM_CFC_TYPE } from '@common/Common';
import { actions } from '@common/redux/modules/Actions';
import HearingResponseInfoModal from '@common/component/organisms/HearingResponseInfoModal';

type VisitProps = RouteComponentProps<{ type: string }>;

const Visit: React.FC<VisitProps> = ({ location }) => {
  const dispatch = useDispatch();
  const loginUser = useSelector((state: AgencyAppState) => state.loginUser);
  const masterInfo = useSelector((state: AgencyAppState) => state.masterInfo);
  const visitSummaryLoadingStatus = useSelector((state: AgencyAppState) => state.loadingStatus.visitReservation);
  const currentTime = useSelector((state: AgencyAppState) => state.loadingStatus.summary.result?.jobDateTime);

  const visitReservationInfo = useSelector((state: AppState) => state.visitReservationInfo);

  const [targetStore, setTargetStore] = useState('');
  const [targetDate, setTargetDate] = useState(getInquiryToday(currentTime));

  // 来店予約データ取得時刻
  const inquiryDate = getInquiryToday(visitSummaryLoadingStatus.result?.jobDateTime);

  useEffect(() => {
    const init = async () => {
      // 既存来店予約情報クリア
      dispatch(actions.visitReservationInfo.init());
      // 取扱商材管理取得APIを実行
      await getVisitStoreList(createVisitStoreListRequest(), dispatch);
    };
    // 初期表示
    init();
  }, []); // eslint-disable-line

  useEffect(() => {
    const summaryExe = async () => {
      if (targetStore && targetDate) {
        // 来店予約サマリ・一覧取得API実行（API処理時に表示する情報をストア設定）
        await getVisitSummary(createVisitSummaryRequest(targetStore, dateToFormatString(targetDate, 'yyyy/MM/dd')), masterInfo, dispatch);
      }
    };
    summaryExe();
  }, [targetStore, targetDate]); // eslint-disable-line

  /**
   * 検索対象の店舗を保持する
   * @param targetStore 選択した店舗コード
   */
  const updateTargetStore = (targetStore: string) => {
    setTargetStore(targetStore);
  };

  /**
   * 取扱商材管理取得APIリクエスト作成
   * @returns
   */
  const createVisitStoreListRequest = (): GetHndlItmMngApiRequest => {
    const targetStores = JSON.parse(JSON.stringify(loginUser.browsableStores));
    return {
      hndlItmMngList: targetStores.map((item: any) => {
        return { agencyCd: item, hndlItmCfc: HNDL_ITM_CFC_TYPE.VISIT_RESERVATION };
      }),
    };
  };

  /**
   * 来店予約サマリ・一覧取得APIリクエスト作成
   * @param agencyCd 代理店コード
   * @param date 検索開始日
   * @returns
   */
  const createVisitSummaryRequest = (agencyCd: string, date: string): GetVisitSummaryApiRequest => {
    return {
      visitSummaryInfoList: [
        {
          agencyCd: agencyCd,
          scheduleStartDate: date,
          scheduleEndDate: date,
        },
      ],
    };
  };

  return (
    <Layout isLoggedIn={true}>
      <VisitDashboard
        path={location.pathname}
        isShowVisitSelectStoreModal={true}
        visitReservationInfo={visitReservationInfo}
        masterInfo={masterInfo}
        loadingStatus={visitSummaryLoadingStatus}
        targetStore={targetStore}
        targetDate={targetDate}
        inquiryDate={inquiryDate}
        updateTargetStore={updateTargetStore}
        updateTargetDate={setTargetDate}
        gaSpotEvent={VISIT_SUMMARY_SPOT_EVENT_MAPPING['AGENCY']}
      />
      <HearingResponseInfoModal
        gaSpotEvent={HEARING_MODAL_SPOT_EVENT_MAPPING['AGENCY']}
        targetDate={targetDate}
        targetStore={targetStore}
      />
    </Layout>
  );
};

export default Visit;
